import {
  DonutIcon,
  EthereumIcon,
  LaptopIcon,
  LogoIcon,
  StarCircleIcon,
  StarIcon,
  SupportIcon,
} from '@endaoment-frontend/ui/icons';
import { Pill } from '@endaoment-frontend/ui/shared';

import { ImageButtonRow } from '../../imageButtonRow';

import styles from './LearnSection.module.scss';

export const LearnSection = () => {
  return (
    <section className={styles['learn-section']}>
      <Pill size="large" variation="blue">
        Learn about Endaoment
      </Pill>
      <h1>Any token, delivered as dollars, to any nonprofit.</h1>
      <div className={styles['learn-details']}>
        <div>
          <SupportIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Interact with real nonprofit experts, at zero cost</p>
        </div>
        <div>
          <LaptopIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Fully on-chain funds, organizations, and allocations</p>
        </div>
        <div>
          <LogoIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Direct Donations, Community Funds, Donor-advised Funds</p>
        </div>
        <div className={styles['coming-soon']}>
          <EthereumIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Facilitated crypto allocations</p>
        </div>
        <div className={styles['coming-soon']}>
          <DonutIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Tax-advantaged portfolios</p>
        </div>
        <div className={styles['coming-soon']}>
          <StarCircleIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Passive funding through fee redistribution</p>
        </div>
      </div>
      <ImageButtonRow title="Learn More About Endaoment">
        <ImageButtonRow.Button
          label="For Donors"
          paragraph="Find out how you can make a difference."
          href="/donors"
          icon={<StarIcon />}
        />
        <ImageButtonRow.Button
          label="For Nonprofits"
          paragraph="Verify your organization and begin fundraising."
          href="/orgs"
          icon={<StarIcon />}
        />
        <ImageButtonRow.Button
          label="For Financial Advisors"
          paragraph="Learn more about products and offerings."
          href="/advisors"
          icon={<StarIcon />}
        />
      </ImageButtonRow>
    </section>
  );
};
